export default __webpack_public_path__ + "static/media/ship.33ce0a8b.png";